import {makeAutoObservable, runInAction} from 'mobx';

import {collect, getClusters, getNotificationCount, getUserInfo, getUserInfoV1, getAppInfoList, getAppMetricData, getAppRmsData, getAppCDData, getAppResourceQuotaData} from '@/api';
import {ackNotification, ackNotificationAll, getTopUnread} from "../api";

class Overview {
  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  totalAppList = [];
  appsList = [];
  user = {};
  current = 1;
  pageSize = 12;
  total = 0;
  permissions = {};
  messageCount = 0;
  messageList = [];
  currentVersion = '';
  loginFirstCall = false;

  setCurrent(page) {
    runInAction(() => {
      this.current = page;
    });
  }

  setPageSize(size) {
    runInAction(() => {
      this.pageSize = size;
    });

  }

  save(bol) {
    setTimeout(() => {
      this.loginFirstCall = bol;
    }, 300);
  }

  //获取用户信息、权限等，不需要访问权限，登录即可访问
  async getUserInfoV1() {
    let res;
    try {
      res = await getUserInfoV1();
      if (res?.data && res?.code === 200) {
        runInAction(() => {
          this.user = res.data?.user || {};
          this.permissions = {
            ...(res.data?.permissions || {}),
            page404: true
            // DASHBOARD_VIEW: false
            // APP_OVERVIEW: true,
            // COST_EXP_VIEW: true
          };
          this.currentVersion = res.data.currentVersion;
        });
      }
    } catch (err) {}

    return res;
  }

    //获取应用信息
    async getAppInfoList({ pageNum = 1, pageSize = 12, searchKey = '', tagIds = [], clusters = [] }) {
        let res;
        const params = {
            pageNum,
            pageSize,
            searchKey,
            tagIds,
            clusters
        };

        try {
            res = await getAppInfoList(params);
            if (res?.data && res?.code === 200) {
                runInAction(() => {
                    this.current = pageNum;
                    this.pageSize = pageSize;
                    this.total = res.data.length;
                    this.totalAppList = res.data;
                    this.appsList = this.totalAppList.slice((pageNum-1)*pageSize, pageNum*pageSize);
                });
                const idList = this.appsList.map(item => item.id);
                this.metricSync(idList)
            }
        } catch (err) {}

        return res;
    }

    flip({ pageNum = 1, pageSize = 12 }) {

        this.appsList = this.totalAppList.slice((pageNum-1)*pageSize, pageNum*pageSize);
        const idList = this.appsList.map(item => item.id);
        this.metricSync(idList);
    }

    metricSync(params){

        getAppMetricData(params).then(response => {
            if (response?.data && response?.code === 200) {
                const map = new Map(response.data.map(item => [item.id, item]));
                runInAction(() => {
                    this.appsList.forEach(app => {
                        const item = map.get(app.id);
                        if (item) {
                            app.cpu = item.cpu;
                            app.memory = item.memory;
                        }
                    });
                })
            }
        })
        getAppRmsData(params).then(response => {
            if (response?.data && response?.code === 200) {
                const map = new Map(response.data.map(item => [item.id, item]));
                runInAction(() => {
                    this.appsList.forEach(app => {
                        const item = map.get(app.id);
                        if (item) {
                            app.pod = item.pod;
                            app.status = item.status;
                        }
                    });
                })
            }
        })
        getAppCDData(params).then(response => {
            if (response?.data && response?.code === 200) {
                const map = new Map(response.data.map(item => [item.id, item]));
                runInAction(() => {
                    this.appsList.forEach(app => {
                        const item = map.get(app.id);
                        if (item) {
                            app.healthy = item.healthy;
                            app.synced = item.synced;
                            app.isHealthy = item.isHealthy;
                        }
                    });
                })
            }
        })
        getAppResourceQuotaData(params).then(response => {
            if (response?.data && response?.code === 200) {
                const map = new Map(response.data.map(item => [item.id, item]));
                runInAction(() => {
                    this.appsList.forEach(app => {
                        const item = map.get(app.id);
                        if (item) {
                            app.cpuRequest = item.cpuRequest;
                            app.cpuLimit = item.cpuLimit;
                            app.memoryRequest = item.memoryRequest;
                            app.memoryLimit = item.memoryLimit;
                        }
                    });
                })
            }
        })
    }

  async getMessageCount() {
    let res;
    try {
      res = await getNotificationCount();
      if (res && res.code === 200) {
        runInAction(() => {
          this.messageCount = res.data?.unreadCount || 0;
        });
      }
    } catch (err) {}
  }

  async getMessageList() {
    let res;
    try {
      res = await getTopUnread(5);
      if (res && res.data && res.code === 200) {
        runInAction(() => {
          this.messageList = res.data;
        });
      }
    } catch (err) {}
  }

  async messageRead(id) {
    let res;
    try {
      res = await ackNotification(id);
      await Promise.all([this.getMessageList(), this.getMessageCount()]);
    } catch (err) {}
    return res;
  }

  async messageReadAll() {
    let res;
    try {
      res = await ackNotificationAll();
      await Promise.all([this.getMessageList(), this.getMessageCount()]);
    } catch (err) {}
    return res;
  }

  async collect(params) {
    let res;
    try {
      res = await collect(params);
    } catch (err) {}

    return res;
  }

  async getClusters() {
    let res;
    try {
      res = await getClusters();
      if (res && res.code === 200) {
        return res.data
      }
    } catch (err) {}
    return res
  }
}

export default new Overview();
